// @flow
import type {
  Season,
} from 'fc-model-seasons/types'

// Libs
import { createSelector } from 'reselect'

// Utils
import sort from '../utils/sort'

// Selectors
import seasons$ from './seasons'

// Exports
export default createSelector(
  [seasons$],
  function (seasons: Array<Season>): Array<Season> {
    return seasons ? sort(seasons) : {}
  },
)
